// Centralized subdomain → tenant slug detection.
// Used by routing AND by the Home Dashboard to surface tenant-specific links.
const RESERVED_SUBS = new Set([
  "www", "app", "preview", "localhost", "aiboxhub", "admin", "api",
]);

export function getSubdomainSlug() {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname;
  const parts = host.split(".");
  if (parts.length < 3) return null;
  const sub = parts[0].toLowerCase();
  if (RESERVED_SUBS.has(sub)) return null;
  if (host.includes("emergentagent.com")) return null;
  return sub;
}
